import $ from 'jquery';
import slick from 'slick-carousel';

class SpotlightTestimonial {
    init() {
        $('.spotlight-testimonial').each(function initSlider() {
            const $component = $(this);
            const $slider = $component.find('.js-spotlight-testimonial-list');

            if (!$slider.length || $slider.hasClass('slick-initialized')) {
                return;
            }

            $slider.slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
                arrows: true,
                adaptiveHeight: true,
                appendDots: $component.find('.js-spotlight-testimonial-dots'),
                prevArrow: $component.find('.js-spotlight-testimonial-prev'),
                nextArrow: $component.find('.js-spotlight-testimonial-next')
            });
        });
    }
}

export default SpotlightTestimonial;

$(() => {
    const spotlightTestimonial = new SpotlightTestimonial();
    spotlightTestimonial.init();
});
